import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgerss from 'material-ui/CircularProgress';
import { ACCENT_COLOR, BLUE_COLOR, DARK_GREY, NEGATIVE_COLOR, LIGHT_GREY } from '../../config/colors';
import { reduxFormValidators } from '../../helpers/validators';
import {
  AdditionalBlock,
  AdditionalBlocks,
  AdditionalBlockText,
  Content,
  FieldsWrap,
  FieldWrap,
  Form,
  FormLoader,
  FormLogo,
  Header,
  ResetPasswordLink,
  styles,
  SubmitBtnWrap,
  ScanIdWrapper
} from './styles';
import { getPaymentKioskLoginMode } from '../../services/paymentKiosk';
import { LOGIN_MODE } from '../../const/paymentKiosk';
import { CloseIcon } from '../../icons';
import { ICON_STYLES } from '../Menu/icon_styles';

const firstFieldValidators = (allowLoginPhoneNumber) => allowLoginPhoneNumber
  ? [reduxFormValidators.requiredValue]
  : [reduxFormValidators.requiredValue, reduxFormValidators.email];

class LoginForm extends Component {
  state = {
    isInputFocused: false
  };

  fields = {
    email: null,
    password: null
  };

  onInputFocus = () => {
    this.setState({
      isInputFocused: true
    });
  };

  onInputBlur = () => {
    this.setState({
      isInputFocused: false
    });
  };

  handleInputEnterPress = (e, inputName, touched, error) => {
    if ((e.key === 'Enter' || String(e.key) === '13') && error === undefined) {
      if (inputName === 'email') {
        e.preventDefault();
        this.onInputBlur();

        setTimeout(() => {
          this.fields.password.focus();
        }, 250);
      } else if (inputName === 'password') {
        this.props.handleSubmit();
      }
    }
  };

  /**
   * Identifies 'compact' mode - some form elements should be hidden, for phones.
   * @returns {Boolean}
   */
  isPhoneCompactMode = () => {
    return false;
  };

  renderHeader = () => !this.isPhoneCompactMode() && (
    <Header style={{ marginBottom: -12 }}>
      <FormLogo />
    </Header>
  );

  renderEmailField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <TextField
      name="email"
      type={"email"}
      ref={ref => {
        this.fields.email = ref;
      }}
      onKeyPress={(e) => this.handleInputEnterPress(e, 'email', touched, error)}
      onFocus={() => this.onInputFocus()}
      onBlur={() => this.onInputBlur()}
      floatingLabelText={<span style={{ color: NEGATIVE_COLOR }}>{"Email" + (this.props.allowLoginPhoneNumber ? " or phone number" : "")}</span>}
      style={styles.inputField}
      errorStyle={styles.submitBtnErrorStyle}
      errorText={(touched && error ? error : '')}
      {...input}
      {...custom}
    />
  );

  renderPasswordField = ({ input, label, meta: { touched, error }, ...custom }) => (
    <TextField
      type="password"
      ref={ref => {
        this.fields.password = ref;
      }}
      onKeyPress={(e) => this.handleInputEnterPress(e, 'password', touched, error)}
      onFocus={() => this.onInputFocus()}
      onBlur={() => this.onInputBlur()}
      floatingLabelText={<span style={{ color: NEGATIVE_COLOR }}>Password</span>}
      style={styles.inputField}
      errorStyle={styles.submitBtnErrorStyle}
      errorText={(touched && error ? error : '')}
      {...input}
      {...custom}
    />
  );

  renderSubmitBtn = () => {
    const { handleSubmit, pristine, valid } = this.props;

    if (this.isPhoneCompactMode()) return <div />;

    return (
      <SubmitBtnWrap>
        <RaisedButton
          onClick={handleSubmit}
          disabled={pristine || !valid}
          backgroundColor={ACCENT_COLOR}
          labelStyle={styles.submitBtnLabel}
          overlayStyle={styles.submitBtnOverlayStyle}
          buttonStyle={styles.submitBtn}
          fullWidth
          label="Sign In"
        />
      </SubmitBtnWrap>
    );
  };

  getEmail = () => {
    if (!this.fields.email || !this.fields.email.input) {
      return '';
    }
    return this.fields.email.input.value;
  }

  renderSignUpLink = () => {
    const { onSignUp } = this.props;

    if (this.isPhoneCompactMode() || !this.props.showSignUp) return <div />;

    return (
      <AdditionalBlock>
        <AdditionalBlockText>Are you a new customer?</AdditionalBlockText>
        <div>
          <RaisedButton
            onClick={() => onSignUp({ email: this.getEmail() })}
            backgroundColor={BLUE_COLOR}
            overlayStyle={styles.submitBtnOverlayStyle}
            labelStyle={styles.submitBtnLabel}
            buttonStyle={styles.submitBtn}
            fullWidth
            label="Sign Up"
          />
        </div>
      </AdditionalBlock>
    );
  };

  renderShoppingLink = () => {
    const { onShopping } = this.props;

    if (!this.props.showShopping) return <div />;

    return (
      <AdditionalBlock>
        <AdditionalBlockText>Don&apos;t know your password?</AdditionalBlockText>
        <div>
          <RaisedButton
            onClick={onShopping}
            backgroundColor={DARK_GREY}
            overlayStyle={styles.submitBtnOverlayStyle}
            labelStyle={styles.submitBtnLabel}
            buttonStyle={styles.submitBtn}
            fullWidth
            label="Start Shopping"
          />
        </div>
      </AdditionalBlock>
    );
  };

  renderScanId = () => {
    const { showIdScanError } = this.props;

    const paymentKioskloginMode = getPaymentKioskLoginMode();
    const isLoginModeWithRedirect = paymentKioskloginMode === LOGIN_MODE.WITH_REDIRECT;

    return (
      <ScanIdWrapper className="scan-id">
        <p>SIGN&nbsp;IN WITH YOUR&nbsp;ID</p>
        <div className="scan-id-description">
          <p>Scan your drivers licence, state&nbsp;ID or&nbsp;passport on&nbsp;the&nbsp;lower left side of&nbsp;the&nbsp;kiosk.</p>
        </div>
        {!isLoginModeWithRedirect && showIdScanError &&
          <div className="scan-id-error">
            <p>Scanning failed, please try&nbsp;again...</p>
          </div>
        }
      </ScanIdWrapper>
    );
  }

  handleForgotPassword = () => {
    const { openResetPassword, openReachOutUsResetPassword, isForgotPasswordByEmailEnabled } = this.props;

    if (isForgotPasswordByEmailEnabled) {
      openResetPassword();
    } else {
      openReachOutUsResetPassword();
    }
  }

  renderLoginInputs = () => {
    const { showForgotPassword, allowLoginPhoneNumber } = this.props;

    const isCompactMode = this.isPhoneCompactMode();

 
    return (
      <FieldsWrap>
        <FieldWrap>
          <Field
            onFocus={() => this.onInputFocus('email')}
            onBlur={() => this.onInputBlur('email')}
            name="email"
            validate={firstFieldValidators(allowLoginPhoneNumber)}
            component={this.renderEmailField}
          />
        </FieldWrap>
        <FieldWrap>
          <Field
            onFocus={() => this.onInputFocus('password')}
            onBlur={() => this.onInputBlur('password')}
            name="password"
            validate={[
              reduxFormValidators.requiredValue,
              reduxFormValidators.minLength,
              reduxFormValidators.maxLength,
            ]}
            component={this.renderPasswordField}
          />
        </FieldWrap>

        {!isCompactMode && showForgotPassword &&
          <ResetPasswordLink onClick={this.handleForgotPassword}>Forgot password?</ResetPasswordLink>
        }
      </FieldsWrap>
    );
  }

  renderAdditionalBlocks = () => {
    const { isKiosk } = this.props;

    const isCompactMode = this.isPhoneCompactMode();

    return (
      <AdditionalBlocks>
        {this.renderSignUpLink()}
        {!isKiosk && !isCompactMode && this.renderShoppingLink()}
      </AdditionalBlocks>
    );
  }

  render() {
    const {
      isUploadInProgress,
      isPaymentKiosk,
      onCloseRequest,
      showCloseIcon,
      showSignInWithIdScan,
      showLoginInputs,
    } = this.props;

    const {
      isInputFocused,
    } = this.state;

    return (
      <Form
        name="loginform"
      >
        <FormLoader loading={isUploadInProgress}>
          <CircularProgerss size={60} thickness={5} />
        </FormLoader>

        {showCloseIcon && (
          <div onClick={onCloseRequest} style={ICON_STYLES.closeBtn}>
            <CloseIcon color={LIGHT_GREY} style={ICON_STYLES.closeIcon} />
          </div>
        )}

        <Content>
          {!isInputFocused && this.renderHeader()}

          {showSignInWithIdScan && this.renderScanId()}

          {showLoginInputs && this.renderLoginInputs()}

          {showLoginInputs && this.renderSubmitBtn()}

          {!isPaymentKiosk && this.renderAdditionalBlocks()}
        </Content>
      </Form>
    );
  }
}

LoginForm.propTypes = {
  allowLoginPhoneNumber: PropTypes.bool.isRequired,
  minLength: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
  isPhone: PropTypes.bool.isRequired,
  isApplePhone: PropTypes.bool.isRequired,
  isUploadInProgress: PropTypes.bool.isRequired,
  onCloseRequest: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
  onShopping: PropTypes.func.isRequired,
  openResetPassword: PropTypes.func.isRequired,
  isKiosk: PropTypes.bool.isRequired,
  showSignUp: PropTypes.bool.isRequired,
  showShopping: PropTypes.bool.isRequired,
  formTitle: PropTypes.string.isRequired,
  showForgotPassword: PropTypes.bool.isRequired,
  showCloseIcon: PropTypes.bool.isRequired,
  isPaymentKiosk: PropTypes.bool.isRequired,
  showSignInWithIdScan: PropTypes.bool.isRequired,
  showIdScanError: PropTypes.bool.isRequired,
  onBeginSignInWithIdScan: PropTypes.func.isRequired,
  onEndSignInWithIdScan: PropTypes.func.isRequired,
  showLoginInputs: PropTypes.bool.isRequired,
  isHubConnected: PropTypes.bool.isRequired
};

export default reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'loginform',
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.jsx